import React from 'react';

const FilterAlertBadge = ({
  top = '-1px',
  right = '-5px',
  size = '20px',
  color = '#566fb1',
  backgroundColor = 'transparent',
}) => {
  return (
    <span
      style={{
        position: 'absolute',
        top,
        right,
        height: size,
        width: size,
        backgroundColor,
        color,
        fontSize: '18px',
        fontWeight: 'bold',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: '1',
        zIndex: 2,
      }}>
      !
    </span>
  );
};

export default FilterAlertBadge;
